
export default {
  props: {
    category: {
      type: Object,
      default: null
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    title() {
      return {
        tag: 'h4',
        html: this.category.name,
        font: 'source'
      }
    },
    image() {
      return {
        fit: 'cover',
        ratio: 'square',
        ...this.categoryImage,
      }
    },
    categoryImage() {
      return this.category.image && this.category.image
    },
    detailsLink() {
      const categoryPath = this.$pagePath({
        name: 'categories-id',
        params: { id: this.category.slug }
      })

      if (this.category.productsCount == 1) {
        return this.$pagePath({
          name: 'products-id',
          params: { id: this.category.products[0].slug }
        })
      } else {
        return categoryPath
      }
    }
  }
}
